import { render, staticRenderFns } from "./classifiersMain.vue?vue&type=template&id=d6f9c7f6&scoped=true&"
import script from "./classifiersMain.vue?vue&type=script&lang=js&"
export * from "./classifiersMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f9c7f6",
  null
  
)

export default component.exports